import React, { useEffect, useState } from "react";
import styles from './requestmobile.module.css';
import { Button, TextField } from "@mui/material";
import { Camera, UploadCloud, X } from "react-feather";
import { useAuth0 } from "@auth0/auth0-react";
import axios from 'axios';
import { toast } from 'react-smart-toaster';

const RequestMobile = ({ isPanelOpen, onToggle, complaintData, setComplaintData, setLoading, setSnackbarMsg, setSnackbarOpen }) => {
    const { user, isAuthenticated, getAccessTokenSilently } = useAuth0();
    const [descVal, setDescVal] = useState('');

    useEffect(() => {
        if (complaintData) {
            setDescVal(complaintData?.description);
        }
    }, [complaintData]);

    useEffect(() => {
        const handler = setTimeout(async () => {

            if (descVal !== '' && complaintData?.id) {
                const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

                return axios.put(process.env.REACT_APP_CASE_API_URL + "v1/complaints/" + complaintData?.id, { description: descVal }, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }).then((response) => {
                    setComplaintData(prev => {
                        return { ...prev, description: response.data.data?.description };
                    });
                }).catch(() => { });
            }
        }, 1000);

        return () => {
            clearTimeout(handler);
        };
    }, [descVal, getAccessTokenSilently]);

    const fileHandler = async (e) => {
        let extErr = false;
        let sizeErr = false;
        let files = e.target.files;
        let allowedExtensionArr = ".jpg,.png,.jpeg".split(',');

        if (files.length > 0) {
            if (allowedExtensionArr.length > 0) {
                let fileName = files[0].name;
                let fileSize = files[0].size;
                let fileNameExt = fileName.substr(fileName.lastIndexOf(".") + 1);
                fileNameExt = '.' + fileNameExt;

                if (allowedExtensionArr.indexOf(fileNameExt) === -1) {
                    extErr = true;
                }

                if (fileSize >= 5242880) {
                    sizeErr = true;
                }
            }
        }

        if (extErr) {
            toast.error("File type is not allowed.");
            return false;
        }

        if (sizeErr) {
            toast.error("File size should not be greater than 5 MB.");
            return false;
        }

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        setLoading(true);

        let formData = new FormData();
        formData.append("image", files[0]);

        axios.post(process.env.REACT_APP_CASE_API_URL + 'v1/complaints/' + complaintData?.id + '/files/upload', formData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then(response => {
            setLoading(false);

            setSnackbarOpen(true);
            setSnackbarMsg('Files uploaded successfully.');

            setComplaintData(prev => {
                let images = response.data.data.concat(prev?.images);
                return { ...prev, images: images };
            });
        }).catch(error => {
            setLoading(false);
        });
    }

    const deleteConfirm = async (itemId) => {
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.delete(process.env.REACT_APP_CASE_API_URL + 'v1/complaints/' + complaintData?.id + '/files/' + itemId, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setLoading(false);

            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);

            setComplaintData(prev => {
                let images = prev?.images?.filter(i => i?.id !== itemId);
                return { ...prev, images: images };
            });
        }).catch(error => {
            setLoading(false);
        });
    }

    return (<>
        <div className={`${styles.AccordionList}`}>
            <div className={`${styles.AccordionListHead} ${isPanelOpen ? styles.Open : ""}`} onClick={() => onToggle("two")}>
                <p className={`${styles.Title}`}>Summary</p>
                <img src="/static/img/downTriangle.svg" />
            </div>
            <div className={`${styles.AccordionListBody} ${isPanelOpen ? styles.Open : ""}`}>
                <div className={`${styles.AccouFormGroup}`}>
                    <form>
                        <div className={`${styles.ReqAddRow}`}>
                            <div className={`${styles.ReqAddFormSec}`}>
                                <div className={`${styles.FormSec}`}>
                                    <div className={`${styles.FormGroupFull} FormGroup`}>
                                        <label className={`${styles.FilterLabel}`}>Describe the Complaint</label>
                                        <TextField id="outlined-multiline-static" label="Add Description*" multiline rows={6} value={descVal} disabled={!(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request:update") > -1)}
                                            onChange={(e) => {
                                                setDescVal(e.target.value);
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className={`${styles.FormIMGSec} ${styles.FileUploadSmall}`}>
                                    <label className={`${styles.FilterLabel}`}>Share Photos</label>
                                    <div className={`${styles.FileIMGDiv}`}>
                                        <div className={`${styles.FileUpDuBUDiv}`}>
                                            <label className={`${styles.TakePhoteBU}`} for="file-upload"><UploadCloud /> Upload Photos</label>
                                            <input id="file-upload" type="file" onChange={fileHandler} accept={".jpg,.png,.jpeg"} />
                                            <p className={`${styles.UploadText}`}>File size upto 10 MB. JPG, PNG file only</p>
                                        </div>

                                        <div className={`${styles.UpIMGSec}`}>
                                            {complaintData?.images?.map((item) => {
                                                return <div className={`${styles.ImgFile}`}>
                                                    <img src={item?.file_public_url} alt="" />
                                                    <Button onClick={(e) => deleteConfirm(item?.id)}> <X /> </Button>
                                                </div>
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </>)
}

export default RequestMobile;